import ModalView from 'common-views/ModalView.js';
import template  from 'dashboard/reports/modal/migrate-report.ejs';
import $ from 'jquery';
import constants from 'Constants.js';

class MigrateReportModal extends ModalView {

    get selectedMigration(){
        return this._selectedMigration;
    }

    set selectedMigration(value){
        this._selectedMigration = value;
    }

    initialize(){
        super.initialize();
        this.template = template;
        this.selectedMigration = constants.IMPORT_INITIAL_VALUE; 
    }

    render(){
        return new Promise((resolve, reject) => {
            const settings = this.settings;
            settings.width = 300;
            settings.buttons = [
                {
                    text: 'OK',
                    disabled: true,
                    'class':'migrateReportOk',
                    click: () => {
                        resolve(this.processMigration());
                        this.closeModal();
                    }
                },
                {
                    text: 'Cancel',
                    click: () => {
                        resolve('Unauthorized');
                        this.closeModal();
                    }
                }
            ];

            settings.open = () => {
                this.addVersionsToSelect(); 
                this.bindEvents();
                // Default first rb to checked, enable OK
                $(`input.action-selector[value='i']`).prop("checked", true);
                this.enableOK();
            };

            if(this.template) {
                this.$el.html(this.template(this.model.toJSON()));
            }
            super.render();

        });
    }

    processMigration(){
        let result = {selection: this.selectedMigration, options: null};
        switch(this.selectedMigration){
            case 'i':
                //import for design
                break;
            case 'n':
                // Export for design
                this.enableVersionPicker();
                result.options = $(constants.DIALOG_ID + ' .version').val();
                break;           
        }
        return result;
    }

    addVersionsToSelect(){
        $('#versions').find('option').remove();
        this.model.get('versions').map( v => {
            $('#versions').append('<option value="' + v + '">' + v + '</option>')
        });
    }

    disableRestricted(){
        $(constants.DIALOG_ID + ' .version').prop('disabled', true);        
    }

    enableExportOptions(){
       
    }

    enableVersionPicker(){
        $(constants.DIALOG_ID + ' .version').prop('disabled', false);
    }

    bindEvents(){
        $(`${constants.DIALOG_ID} input.transfer-ownership`).click( e => {
            const newVal = e.currentTarget.value;
            this.selectedMigration = constants.DASHBOARD_XFER_OWNERSHIP;
        });

        $(constants.DIALOG_ID + ' input.action-selector').click((e)=>{
            const newVal = e.currentTarget.value;

            if(newVal !== this.selectedMigration){
                this.selectedMigration = newVal;
                this.enableOK();
                this.selectMigrationType(newVal);
            }
        });        
    }

    enableOK(){
        $('button.migrateReportOk').button("enable")
    }

    selectMigrationType(newVal){
        this.disableRestricted();

        switch(newVal) {            
            case 'n':
                this.enableVersionPicker();
                break;
        }
    }
   
}

export default MigrateReportModal;